class Controller {
  constructor($mdDialog, $injector, admin) {
    "ngInject";

    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.admin = admin;
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporate/removeAdminDialog/removeAdminDialog.controller.js